import { useMemo } from 'react'
import { ColumnDef } from '@tanstack/react-table'
import { IDColumn, DetailColumn, selectableColumns } from './columns'
import { useCompanyDetailContextValue } from '../../../../context/CompanyDetailProvider'

type Shifts = ReturnType<
  typeof useCompanyDetailContextValue
>['state']['shifts']['data']['items']

export const useSelectedColumns = (): ColumnDef<Shifts[number]>[] => {
  const {
    state: {
      shifts: { selectedColumnsFilters },
    },
  } = useCompanyDetailContextValue()

  const columnsToDisplay = useMemo(() => {
    const filteredColumns = selectableColumns
      .filter((column) => selectedColumnsFilters.includes(column.id))
      .map((column) => column.columnDef)

    return [IDColumn, ...filteredColumns, DetailColumn]
  }, [selectedColumnsFilters])

  return columnsToDisplay
}
